<template>
    <p  class="form-item-nopadding form-item-bottom selected-ellipsis">
        <span class="jc-form-item__label w70"
            :title="$t('create.text.original')">{{$t('create.text.original')}}</span>
        <span class="price originPrice">￥{{originPrice}}</span>
        <span class="ml20 highlight-font-color cff96" :title="'￥'+ totalDiscount">{{$t('create.text.save')}}：￥{{totalDiscount}}</span>
    </p>
</template>

<script>
export default {
    name: 'SavePrice',
    props: {
        totalDiscount: {
            type: Number | String,
            default: 0
        },
        originPrice: {
            type: Number | String,
            default: 0
        }
    },
    data() {
        return {

        }
    },
    methods: {
    },
};
</script>

<style scoped lang="scss">
.originPrice {
    font-size:12px;
    text-decoration:line-through;
    margin:6px 0;
    margin-left:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SavePrice.vue